module.exports = __webpack_public_path__ + "img/back.58058772.svg";